import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';

import { useDispatch } from 'react-redux';
import LogsTable from './LogsTable';
import FullPageLoader from 'components/common/FullPageLoader';
import { fetchInterpreterAppointmentView } from 'slices/interpreter/appointmentSlice';
import { fetchInterpreterAppointmentLogs } from 'slices/interpreter/appointmentSlice';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import toast from 'react-hot-toast';
import { CheckinCheckoutAdjustmentModal } from 'components/appointment/checkinCheckoutAdjustment';
import CouldNotCover from 'components/appointment/CouldNotCover';
import DonotCover from 'components/appointment/DonotCover';
import CancelModal from 'components/appointment/CancelModal';
import { setActionAssign } from 'slices/actionButtonSlice';
import ViewTable from 'views/appointment/view/ViewTable';
import moment from 'moment';
import Swal from 'sweetalert2';

const AppointmentView = () => {

    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [item, setItem] = React.useState({});
    const [loading, setLoading] = React.useState(false)
    const [logs, setLogs] = React.useState([]);
    const [cancelModal, setCancelModal] = React.useState(false);
    const [donotCover, setDonotCover] = React.useState(false);
    const [couldNotCover, setCouldNotCover] = React.useState(false);
    const [checkinCheckoutModal, setCheckinCheckoutModal] = React.useState(false);


    const callViewApi = async () => {
        const callBack = (success, message, data) => {
            setLoading(false);
            if (success) {
                setItem(data)
                console.log(data)
            }
            else {
                console.log(message)
            }
        }

        dispatch(fetchInterpreterAppointmentView(id, callBack))
    };

    const fetchLogs = async () => {
        const callBack = (success, message, data) => {
            if (success) {
                setLogs(data)
                console.log(data)
            }
            else {
                console.log(message)
            }
            // setLogs()
        }
        dispatch(fetchInterpreterAppointmentLogs(id, callBack))
    }

    React.useEffect(() => {
        setLoading(true)
        callViewApi();
        // fetchLogs();

    }, [id]);
    const handleCancel = () => {
        setCancelModal(true);
    };
    const handleCloseCancel = () => {
        setCancelModal(false);
    };
    const handleDonotCover = () => {
        setDonotCover(true);
    };
    const handleCloseDonotCover = () => {
        setDonotCover(false);
    };
    const handleCouldNotCover = () => {
        setCouldNotCover(true);
    };
    const handleCloseCouldNotCover = () => {
        setCouldNotCover(false);
    };
    const handleOpenCheckinCheckoutModal = () => {
        setCheckinCheckoutModal(true);
    };
    const handleCloseCheckinCheckoutModal = () => {
        setCheckinCheckoutModal(false);
    };
    const handleSubmit = (data, end_point, callBack , modalTitle = 'Are you sure?') => {
        const submitCallback = (success, message) => {
            callBack && callBack()

            if (success) {
                handleCloseCancel();
                handleCloseDonotCover();
                handleCloseCouldNotCover();
                handleCloseCheckinCheckoutModal()
                callViewApi();
                fetchLogs()
                toast.success(message, {
                    className: "successToast",
                });
                setLoading(false)
                if (end_point == 'decline-invite' || end_point == 'assign-vendor') {
                    navigate("/interpreter/appointments");
                    
                }
            }
            else {
                // toast.error(message,
                //     { className: "errorToast", }
                // );
                // setLoading(false)
                toast.error(message, { className: "errorToast" });

                handleCloseCancel();
                handleCloseDonotCover();
                handleCloseCouldNotCover();
                handleCloseCheckinCheckoutModal();

                navigate("/interpreter/appointments");
                setLoading(false);
            }
        }
        new Swal({
                    title: modalTitle,
                    text: "",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, confirm!',
                })
                    .then((result) => {
                        if (result.isConfirmed) {
                            setLoading(true)

                            dispatch(
                                setActionAssign(
                                    id,
                                    data,
                                    end_point,
                                    submitCallback
                                )
                            )
                        }
                        else {
                            
                        }
                    })
        
        
    }
    const rawDatetime = item?.date + " " + item?.start_time;

    const formattedDate = moment(rawDatetime, 'YYYY-MM-DD HH:mm:ss').format('MMM D, YYYY HH:mm:ss');
    console.log('this is items',item);
    return (
        <div className="content" style={{}}>
            {loading && <FullPageLoader />}

            <div className="row_main_head bg-primary-secondaryCard">
                <h2 className={`main_heading main_heading1`}>View Appointment # {item?.appid}</h2>

            </div>
            <div className="row_main_head bg-light-secondaryCard asdas">
                <h2 className={`main_heading2 d-flex align-items-center flex-wrap gap-1`} toLowerCase={'text-lowercase'}>Date & Time <span className="dateTime">{formattedDate}</span></h2>
                <div className=''>
                    <div className='text-transform-capitalize main_heading2 d-flex align-items-center flex-wrap gap-1 justify-content-end' >
                        {item?.status && <span className="appointmentType d-block">{item?.status}</span>}
                        <span className="appLanguage d-block">{item?.language?.name || item?.language_other}</span>
                    </div>
                </div>
            </div>
            <div className="card_table view_table_custom">
                <div className='row-primary flex-wrap'>
                    {/* {(item?.status !== "DNC" && item?.status !== "cancelled") && <SubmitButton buttonType="button" btnText="Donot Cover" className="yellow" handleSubmit={handleDonotCover} />}
                    {(item?.status !== "CNC" && item?.status !== "cancelled") && <SubmitButton buttonType="button" btnText="Could Not Cover" className="yellow" handleSubmit={handleCouldNotCover} />} */}
                    {(item?.status == "pending" || item?.status == "assigned") && <SubmitButton buttonType="button" className={'tomatoRed'} btnText="Decline" handleSubmit={handleCancel} />}
                    {(item?.status == "pending") &&
                        <>
                            <SubmitButton
                            buttonType="button"
                            btnText="Accept"
                            handleSubmit={() => handleSubmit(
                                { interpreter_id: item?.interpreter_id },
                                "assign",
                                () => console.log("Appointment accepted successfully!")
                            )}
                            />
                        </>
                    }
                    {(item?.status == "declined") && 
                        <>
                            <SubmitButton
                            buttonType="button"
                            btnText="Send To Excel"
                            handleSubmit={() => handleSubmit(
                                { interpreter_id: item?.interpreter_id },
                                "assign-to-vendor",
                                () => console.log("Appointment accepted successfully!"),
                                "Are you sure you want to send this appointment to Excel?"
                            )}
                            />
                        </>
                    }
                    {item?.status == "assigned" &&
                        <SubmitButton buttonType="button" className="Cancle_button"
                            btnText="Checkin / checkout"
                            data-bs-toggle="modal"
                            data-bs-target="#checkinCheckoutAdjustmentModal" handleSubmit={handleOpenCheckinCheckoutModal} />
                    }

                    {(item?.status == "available") &&
                        <>
                            <SubmitButton
                            buttonType="button"
                            btnText="Accept Invite"
                            handleSubmit={() => handleSubmit(
                                { interpreter_id: item?.interpreter_id },
                                "accept-invite",
                                () => console.log("Appointment accepted successfully!")
                            )}
                        />
                        <SubmitButton
                            buttonType="button"
                            btnText="Decline Invite"
                            className={"tomatoRed"}
                            handleSubmit={() => handleSubmit(
                                { interpreter_id: item?.interpreter_id },
                                "decline-invite",
                                () => console.log("Appointment accepted successfully!")
                            )}
                            />
                        </>
                    }
                    

                </div>

                <ViewTable item={item} />
            </div>

            {/* <div className="card_table p-4">
                <div className="row_main_head mb-3">
                    <h2 className={`main_heading`}>Appointment Logs</h2>
                </div>
                <LogsTable logs={logs} />
            </div> */}

            <CancelModal
                isOpen={cancelModal}
                onClose={handleCloseCancel}
                onConfirm={handleSubmit}
                appointmentId={id}
                item={item}
                loader={loading}
            />
            <DonotCover
                isOpen={donotCover}
                onClose={handleCloseDonotCover}
                onConfirm={handleSubmit}
                appointmentId={id}
                item={item}
                loader={loading}
            />
            <CouldNotCover
                isOpen={couldNotCover}
                onClose={handleCloseCouldNotCover}
                onConfirm={handleSubmit}
                appointmentId={id}
                item={item}
                loader={loading}
            />
            <CheckinCheckoutAdjustmentModal
                isOpen={checkinCheckoutModal}
                handleClose={handleCloseCheckinCheckoutModal}
                onConfirm={handleSubmit}
                appointmentId={id}
                onSubmit={handleSubmit}
                item={item}
                loader={loading}
            />
        </div>
    )
}





export default AppointmentView